<template>
  <div class="winners-2019-place-winners-card">
    <h3 class="winners-2019-place-winners-card__title">
      <img
        class="winners-2019-place-winners-card__img"
        v-if="img"
        :src="img"
        alt=""
      />
      <slot name="title" />
    </h3>
    <Winners2019PlaceWinnersCardSubtitle>
      Награда
    </Winners2019PlaceWinnersCardSubtitle>
    <div class="winners-2019-place-winners-card__prize">
      <slot name="prize" />
    </div>
    <Winners2019PlaceWinnersCardSubtitle>
      Победители
    </Winners2019PlaceWinnersCardSubtitle>
    <div class="winners-2019-place-winners-card__winners-wrapper">
      <ul
        v-if="winners_1.length"
        class="winners-2019-place-winners-card__winners"
      >
        <li
          class="winners-2019-place-winners-card__winner-li"
          v-for="(winner, index) in winners_1"
          :key="index"
        >
          <UserBadge
            class="winners-2019-place-winners-card__winner"
            :user="winner"
          />
        </li>
      </ul>
      <ul
        v-if="winners_2.length"
        class="winners-2019-place-winners-card__winners"
      >
        <li
          class="winners-2019-place-winners-card__winner-li"
          v-for="(winner, index) in winners_2"
          :key="index"
        >
          <UserBadge
            class="winners-2019-place-winners-card__winner"
            :user="winner"
            avatar-color="red"
          />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Winners2019PlaceWinnersCardSubtitle from "./Winners2019PlaceWinnersCardSubtitle";
import UserBadge from "@/components/user/UserBadge";

export default {
  name: "Winners2019PlaceWinnersCard",
  components: {
    Winners2019PlaceWinnersCardSubtitle,
    UserBadge
  },
  props: {
    img: String,
    winners_1: {
      type: Array,
      default: () => []
    },
    winners_2: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style lang="scss">
.winners-2019-place-winners-card {
  text-align: center;
  background: linear-gradient(180deg, rgba(#171a29, 0.8), rgba(#071c52, 0.8));
  border-radius: 6px;
  font-family: "Montserrat";
  line-height: 1.2;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 45px 35px 40px;

  &__title {
    font-size: 50px;
    margin-bottom: 45px;
    padding-left: 127px;
    text-shadow: 0px 3px 40px #7923a6, 0px 4px 20px #000000;
    position: relative;
  }

  &__img {
    position: absolute;
    top: 50%;
    left: 5px;
    max-height: 122px;
    width: 111px;
    transform: translateY(-50px);
  }

  &__prize {
    margin: 20px 0 40px;
    font-size: 20px;
    font-weight: bold;
    text-shadow: 0px 4px 20px #000;
  }

  &__winners-wrapper {
    display: flex;
    justify-content: center;
    width: 100%;
  }

  &__winners {
    list-style: none;
    max-width: calc(100% + 10px);
    &:first-child {
      margin-right: 14px;
    }
    &:only-child {
      margin: 0 auto;
    }
  }

  &__winner {
    width: 247px;
    max-width: 100%;
  }

  &__winner-li {
    &:not(:last-child) {
      margin-bottom: 18px;
    }
  }

  .text-big {
    font-size: 28px;
  }

  @include breakpoint("sm-and-down") {
    &__winners-wrapper {
      flex-wrap: wrap;
    }
    &__winners {
      padding: 5px;
      &:first-child {
        margin-right: 0;
      }
    }
  }

  @include breakpoint("xs-only") {
    padding: 30px 15px 20px;
    &__img {
      width: 90px;
      transform: translateY(-40px);
    }
    &__title {
      font-size: 30px;
      padding-left: 100px;
    }
  }
}
</style>
